import React from 'react'
import { formatPhoneNumber } from '../utility/utility'

const component = function({format, ...otherProps}) {
  const defaultPhoneNumber = '7182220066';
  return (
    <a href={`tel:${defaultPhoneNumber}`} {...otherProps}>
      {formatPhoneNumber(defaultPhoneNumber, {delimiterType: format})}
    </a>
  );
}

component.displayName = 'PhoneNumber';
export default component;



// WEBPACK FOOTER //
// ./client/components/PhoneNumber.js